import React from "react";
import { Card } from "./card";

function Header() {
  return (
      <Card></Card>
  );
}

export { Header };
